import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IActTeamMemberActions, IThunkUnlockTeamMember } from '../types';

const onUnlockTeamMember: IThunkUnlockTeamMember = thunk(
  async ({ activateTeamMember }: Actions<IActTeamMemberActions>, payload) => {
    const { clinicId, actTeamId, teamMemberId } = payload;

    await api.actTeamMember.unlockTeamMember(clinicId, actTeamId, teamMemberId);

    activateTeamMember(teamMemberId);
  },
);

export default onUnlockTeamMember;
